import { DotsThreeOutline } from '@phosphor-icons/react';
import { Button } from 'src/v2/commonComponents/Button';
import { QUICK_SKILL_COMMANDS, SVG_SIZE_M } from 'src/constants';
import { ToggleProps } from 'src/v2/commonComponents/DrawerTooltipContainer';
import { useSkillCommand, useBreakpoint } from 'src/hooks';
import { QuickSkillCommand } from 'src/types';
import { useMemo } from 'react';

export const SkillCommandMoreToggle = ({
  id,
  isActive,
  disabled,
  onClick,
}: ToggleProps) => {
  const { isDesktopAndUp } = useBreakpoint();
  const { activeSkillCommand } = useSkillCommand();

  const moreOptions = useMemo(
    () => [
      QuickSkillCommand.VIDEO,
      ...(!isDesktopAndUp
        ? [QuickSkillCommand.IMAGE, QuickSkillCommand.THINKING]
        : []),
    ],
    [isDesktopAndUp],
  );

  const isSelected = useMemo(
    () => !!activeSkillCommand && moreOptions.includes(activeSkillCommand),
    [activeSkillCommand, moreOptions],
  );
  const SelectedIcon =
    activeSkillCommand && isSelected
      ? QUICK_SKILL_COMMANDS.find((item) => item.skill === activeSkillCommand)
          ?.Icon
      : null;

  return (
    <Button
      id={id}
      onClick={onClick}
      color={isActive || !!SelectedIcon ? 'tertiary' : 'secondary'}
      disabled={disabled}
      shape="round"
    >
      {!!SelectedIcon ? (
        <SelectedIcon size={SVG_SIZE_M} />
      ) : (
        <DotsThreeOutline size={SVG_SIZE_M} />
      )}
    </Button>
  );
};
